import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../../common/models/api-response.model';
import { Insight } from '../../../../common/models/insight.model';
import { StepTask } from '../../../../common/models/assign-to-me.model';
import { MyInboxService } from '../../../../common/services/my-inbox/my-inbox.service';
import { TenantService } from '../../../../common/services/tenant/tenant.service';
import { ENDPOINTS } from '../../../../common/constants/endpoints.constants';
import { VENDOR_ROUTES } from '../../../../common/constants/vendor.routing.constants';
import { RequestTypeEnum } from '../../../../common/enums/request-type';
import {
  AssignedTasksAdapter,
  AssignedTasksSort,
  AssignedTasksUiFeatures,
} from './assigned-tasks.adapter';

@Injectable({ providedIn: 'root' })
export class VendorAssignedTasksAdapter implements AssignedTasksAdapter {
  private readonly myInboxService = inject(MyInboxService);
  private readonly tenantService = inject(TenantService);

  readonly uiFeatures: AssignedTasksUiFeatures = {
    showResourceTypeFilter: false,
    showOnHold: false,
    showProjectLink: false,
  };

  private readonly vendorEndpoints = {
    steps: ENDPOINTS.VendorPortal.Inbox.Steps,
    insights: ENDPOINTS.VendorPortal.Inbox.StepInsights,
    export: ENDPOINTS.VendorPortal.Inbox.ExportSteps,
  };

  getTasks(
    page: number,
    perPage: number,
    filter: string,
    sort: AssignedTasksSort,
    search: string,
    additionalFilters?: Record<string, string | string[]>
  ): Observable<ApiResponse<StepTask>> {
    return this.myInboxService.getStepsAssignToMe(
      page,
      perPage,
      filter,
      sort,
      search,
      additionalFilters,
      { url: this.vendorEndpoints.steps }
    );
  }

  getInsights(): Observable<{ data: Insight[] }> {
    return this.myInboxService.getAssignedToMeInsights({
      url: this.vendorEndpoints.insights,
    });
  }

  exportTasks(form: Record<string, unknown>): Observable<unknown> {
    return this.myInboxService.exportAssignedToMe(form, {
      url: this.vendorEndpoints.export,
    });
  }

  getTaskRouterLink(taskId: number, flowId: number): string[] {
    return [
      this.tenantService.vendorPath(
        `${VENDOR_ROUTES.MY_INBOX.ASSIGNED_TASKS}/${taskId.toString()}/${RequestTypeEnum.ACTION}/${flowId.toString()}`
      ),
    ];
  }

  getRelatedRequestViewLink(childFlowId: number): string {
    return this.tenantService.vendorPath(
      `${VENDOR_ROUTES.MY_INBOX.REQUEST}/${RequestTypeEnum.VIEW}/${childFlowId}`
    );
  }
}
